
import {Component, Prop, Vue} from "vue-property-decorator";
import UcretliSorguOnayDialog from "@/components/eicrapro/sorgu/UcretliSorguOnayDialog.vue";
import {
  kaynakBayatMi,
  kaynakTarihiMetni,
  kaynakTazeKadarMetni,
  kaynakYasiMetni,
  snapshottanMi,
} from "@/components/eicrapro/sorgu/sorguKaynagi";

/**
 * Faz 4 İP3 (DEV-3217) — sorgu sonucunun KAYNAĞINI gösteren rozet + bilinçli Yenile.
 *
 * Rozet YALNIZ snapshot kökenli cevapta görünür: `UyapRequest` snapshot
 * yolundan dönerken gövdeye `snapshotKaynagi` ve `snapshotDamgasi` koyuyor ve
 * aynı gövde IndexedDB'ye de yazılıyor — o kayıt okunduğunda rozet görünmeye
 * devam eder (veri gerçekten o damgadaki koşumdan geliyor). Canlı cevapta bu
 * alanlar yoktur ve rozet hiç render edilmez; bugünkü işaretsiz davranış
 * korunur. Ayrıntı: `sorguKaynagi.ts`.
 *
 * "Yenile" ücret uyarısı onaylanmadan çalışmaz; onaylanınca ebeveyn bileşen
 * sorguyu `.fresh()` (forceFresh) ile koşar.
 *
 * DEV-3346-B24: chip her yaşta aynı nötr renkteydi ve metni sabit "sorgusundan"
 * idi — kullanıcı dünkü veri ile günler önceki veriyi ayırt edemiyordu. Artık
 * metne yaş ekleniyor ("· dün") ve tazelik penceresi dolduysa (`bayatMi`)
 * chip uyarı tonuna, ikon `mdi-clock-alert-outline`'a dönüyor; karar mantığı
 * `sorguKaynagi.ts`'te.
 */
@Component({components: {UcretliSorguOnayDialog}})
export default class SorguKaynakRozeti extends Vue {
  /** Sorgu cevabı (ISorguSonuc). Şekli tanınmıyorsa rozet gösterilmez. */
  @Prop() kaynak!: any;
  /** Onay diyaloğunda gösterilecek okunur alan adı. */
  @Prop({default: ""}) alanAdi!: string;
  /** Verilirse onay diyaloğu günlük hak durumunu UYAP'a sorar. */
  @Prop() dosyaId!: string | number;
  @Prop({default: false}) yukleniyor!: boolean;

  onayAcik = false;

  /**
   * "Şimdi" — DEV-3346-B24: `yasMetni`/`bayatMi` zamana göre değişir ama
   * `new Date()` reaktif DEĞİL; bu alan olmadan Vue 2'nin computed cache'i
   * yalnız `kaynak` prop'unun REFERANSI değiştiğinde yeniden hesaplar ve chip,
   * sekme uzun süre açık kalsa bile ilk render anındaki yaşta donar kalırdı.
   * Dakikada bir güncellenerek getter'ların reaktif bir zaman kaynağı okumasını
   * sağlar (bkz. `mounted`/`beforeDestroy`).
   */
  private suAn: Date = new Date();
  private suAnAraligi: number | null = null;

  mounted() {
    this.suAnAraligi = window.setInterval(() => {
      this.suAn = new Date();
    }, 60 * 1000);
  }

  beforeDestroy() {
    if (this.suAnAraligi !== null) {
      clearInterval(this.suAnAraligi);
    }
  }

  get snapshottanMi(): boolean {
    return snapshottanMi(this.kaynak);
  }

  /** "28.08.2026" — kullanıcı hangi güne baktığını görsün. */
  get damgaMetni(): string {
    return kaynakTarihiMetni(this.kaynak);
  }

  /** "bugün" / "dün" / "N gün önce" — DEV-3346-B24: dünkü veri ile günler önceki veri rozette ayırt edilsin. */
  get yasMetni(): string {
    return kaynakYasiMetni(this.kaynak, this.suAn);
  }

  /** Tazelik penceresi doldu mu — dolduysa chip uyarı tonuna döner (DEV-3346-B24). */
  get bayatMi(): boolean {
    return kaynakBayatMi(this.kaynak, this.suAn);
  }

  /** "DD.MM.YYYY HH:MM'e kadar taze" ya da "" — tooltip'e ek bilgi. */
  get tazeKadarMetni(): string {
    return kaynakTazeKadarMetni(this.kaynak);
  }

  onayIste() {
    // Koşum sürerken yeni bir onay açılmaz: her onay ÜCRETLİ bir canlı sorgu
    // demek, çift tıklama iki hak/ücret yakabilirdi.
    if (this.yukleniyor) {
      return;
    }
    this.onayAcik = true;
  }

  yenile() {
    if (!this.onayAcik || this.yukleniyor) {
      return;
    }
    // Önce kapat: diyalog kapanana kadar gelen ikinci tıklama bu kapıdan döner.
    this.onayAcik = false;
    this.$emit("yenile");
  }
}
